import trace from "./trace.mjs";
import { LoginDialog } from "./dialogs/login-dialog.mjs";
import { PostcodeSearchDialog } from "./dialogs/postcode-search.mjs";
import { ResetPasswordDialog } from "./dialogs/reset-password.mjs";
import { dialogBoxManager } from "./dialogs/manager.mjs";
import { mediaQueryState } from "./responsive.mjs";
import { TalkToExpertDialog } from "./dialogs/talk-to-expert.mjs";
import { PriceListDialog } from "./dialogs/price-list.mjs";


window._dbm = ( event, dialog, not_mobile ) => {

    if( not_mobile && mediaQueryState.isMobile() )
        return true;

    let dialogs = {
        login     : () => new LoginDialog(),
        postcode  : () => new PostcodeSearchDialog(),
        forgotten : () => new ResetPasswordDialog(),
        expert    : () => new TalkToExpertDialog(),
        prices    : () => new PriceListDialog()
    };

    if( dialog in dialogs ) {
        event.preventDefault();
        trace.info( 'Dialog dispatcher: Requesting dispatch', dialog );
        dialogBoxManager.pushDialog( dialogs[dialog]() );
        return false;
    }

    console.warn('Dialog dispatcher: no handler for dialog', dialog );
    return true;
}
